import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { adminDialogPanel, adminIconBtn, adminOverlay } from '@/components/admin/adminUi';

export default function DeleteConfirmDialog({ isOpen, onClose, onConfirm, vehicleName }) {
  if (!isOpen) return null;

  return (
    <div className={adminOverlay()}>
      <div className={`${adminDialogPanel('max-w-md')} border-red-500/30`}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-500/10 border border-red-500/30">
              <AlertTriangle className="w-6 h-6 text-red-400" />
            </div>
            <h2 className="text-xl font-['Unbounded'] font-bold text-white">
              Delete Vehicle
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className={adminIconBtn}
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-white/80 font-['Manrope']">
            Are you sure you want to delete <span className="font-semibold text-white">{vehicleName}</span>?
          </p>
          <p className="text-white/60 font-['Manrope'] text-sm">
            This action cannot be undone. All vehicle data will be permanently removed.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3 p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] border-t border-white/10">
          <button
            type="button"
            onClick={onClose}
            className="min-h-11 px-6 py-2 border border-white/10 text-white/80 hover:bg-white/5 transition-colors font-['Manrope']"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="min-h-11 px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-['Manrope'] font-semibold transition-colors"
          >
            Delete Vehicle
          </button>
        </div>
      </div>
    </div>
  );
}
